import style from '../../store/json/badge_style.json'

const {
    _bg,
    _class,
    _icon
} = style

export default {
    methods: {
        requestType(type, icon, bg) {
            type = (!type) ? 'unknown' : type

            if (icon) {
                return `<i data-feather="${_icon[type]}"></i>`
            }

            if (bg) {
                return _bg[type]
            }

            return _.startCase(`${type} Request`)
        },
        requestStatus(status, isBlock = false) {
            const block = isBlock ? 'd-block' : ''
            status = (!status) ? 'unknown' : status

            return `<span class="badge badge-sm badge-dim ${
                _class[status.toLowerCase()]
            } ${block}">${status.toUpperCase()}</span>`
        },
        holdingValue({
            units,
            with_holding_amount,
            security_details: {
                price: {
                    value
                }
            }
        }) {
            return (parseFloat(units) * parseFloat(value)) - parseFloat(with_holding_amount)
        }
    }
}
